import { render, staticRenderFns } from "./LessonsSection.vue?vue&type=template&id=44904c43&scoped=true&"
import script from "./LessonsSection.vue?vue&type=script&lang=js&"
export * from "./LessonsSection.vue?vue&type=script&lang=js&"
import style0 from "./LessonsSection.vue?vue&type=style&index=0&id=44904c43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44904c43",
  null
  
)

export default component.exports